import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalGiaHan } from "./ModalGiaHan";

export const BtnGiaHan = ({ TaiSanID }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Gia hạn"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
            <img src="/app-assets/images/icon-gia-han-v3.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <ModalGiaHan show={show} onHide={handleClose} TaiSanID={TaiSanID} />
      )}
    </>
  );
};
